module.exports = __webpack_public_path__ + "img/jucai7.73d92de1.jpg";